class LocaleLoadError extends Error {
  constructor(localeCode, localePath, error = '') {
    super(error)
    this.name = 'LocaleLoadError'
    this.message = `Error while loading locale. localeCode "${localeCode}", localePath "${localePath}". ${error}`
  }
}
export default LocaleLoadError
